import { render, staticRenderFns } from "./oneStopProcessingProve.vue?vue&type=template&id=020ec81e&scoped=true&"
import script from "./oneStopProcessingProve.vue?vue&type=script&lang=js&"
export * from "./oneStopProcessingProve.vue?vue&type=script&lang=js&"
import style0 from "./oneStopProcessingProve.vue?vue&type=style&index=0&id=020ec81e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ec81e",
  null
  
)

export default component.exports